import React, {useState} from "react";
import {UsersTranslationKey} from "./UsersTranslationKey";
import {_transl} from "../../../../store/localization/TranslMessasge";
import {CancelButton} from "../../../../components/button/CancelButton";
import userService from "../../../../common/apis/user/UserApiClient";
import Snackbar from "../snackbar/Snackbar";
import DialogActions from "../../../../components/dialogs/DialogActions";
import {ChangePasswordButton} from "../../../../components/button/ChangePasswordButton";
import Grid from "../../../../components/dialogs/Grid";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import DialogContent from "../../../../components/dialogs/DialogContent";
import PasswordTextField from "../../../../components/fields/textfield/PasswordTextField";
import {CommonTranslationKey} from "../CommonTranslationKey";

interface UserPasswordChangeDialogProps {
    open: boolean,
    userLogin: string,
    onClose: () => void,
    onPasswordChangeSuccess?: () => void,
}

export function UserPasswordChangeDialog(props: UserPasswordChangeDialogProps) {
    const {userLogin, onPasswordChangeSuccess, onClose, open} = props;

    const [oldPassword, setOldPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [repeatedPassword, setRepeatedPassword] = useState<string>("");
    const [oldPasswordErrorMessage, setOldPasswordErrorMessage] = useState<string>();
    const [newPasswordErrorMessage, setNewPasswordErrorMessage] = useState<string>();
    const [repeatedPasswordErrorMessage, setRepeatedPasswordErrorMessage] = useState<string>();

    function setAllStatesToDefault() {
        setOldPassword("");
        setNewPassword("");
        setRepeatedPassword("");
        setNewPasswordErrorMessage(undefined);
        setRepeatedPasswordErrorMessage(undefined);
        setOldPasswordErrorMessage(undefined);
    }

    function validate(): boolean {
        let isValid = true;

        if (oldPassword.length === 0) {
            setOldPasswordErrorMessage(_transl(CommonTranslationKey.FILL_OUT_THIS_FIELD));
            isValid = false;
        } else {
            setOldPasswordErrorMessage(undefined);
        }
        if (newPassword.length < 4 || newPassword.length > 128) {
            setNewPasswordErrorMessage(_transl(UsersTranslationKey.CHANGE_PASSWORD_INVALID_PASSWORD));
            isValid = false;
        } else {
            setNewPasswordErrorMessage(undefined);
        }
        if (newPassword.normalize("NFC") !== repeatedPassword.normalize("NFC")) {
            setRepeatedPasswordErrorMessage(_transl(UsersTranslationKey.CHANGE_PASSWORD_REPEATED_PASSWORD_NOT_MATCH));
            isValid = false;
        }
        if (newPassword.normalize("NFC") === oldPassword.normalize("NFC")) {
            setNewPasswordErrorMessage(_transl(UsersTranslationKey.CHANGE_PASSWORD_NEW_PASSWORD_IS_THE_SAME_AS_OLD_ONE));
            isValid = false;
        } else {
            setRepeatedPasswordErrorMessage(undefined);
        }

        return isValid;
    }

    function saveChanges() {
        setOldPassword(oldPassword.trim());
        setNewPassword(newPassword.trim());
        setRepeatedPassword(repeatedPassword.trim());

        if (validate()) {
            userService.changePassword(userLogin, oldPassword, newPassword)
                    .then(() => {
                        Snackbar.success(_transl(UsersTranslationKey.CHANGE_PASSWORD_SUCCEEDED));
                        onDialogClosed();
                        onPasswordChangeSuccess && onPasswordChangeSuccess();
                    })
                    .catch((error) => {
                        Snackbar.error(_transl(UsersTranslationKey.CHANGE_PASSWORD_FAILED), error);
                    });
        }
    }

    function onDialogClosed() {
        setAllStatesToDefault();
        onClose();
    }

    return (
        <Dialog open={open} onClose={onDialogClosed}>
            <DialogTitle title={_transl(UsersTranslationKey.CHANGE_PASSWORD_TITLE)}
                         onDialogClosed={onDialogClosed}
            />
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <PasswordTextField
                            id="change-user-pwd-dialog-old-pwd-field"
                            label={_transl(UsersTranslationKey.CHANGE_PASSWORD_OLD_PASSWORD)}
                            errorMessage={oldPasswordErrorMessage}
                            onChange={(value) => setOldPassword(value)}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <PasswordTextField
                            id="change-user-pwd-dialog-new-pwd-field"
                            label={_transl(UsersTranslationKey.CHANGE_PASSWORD_NEW_PASSWORD)}
                            errorMessage={newPasswordErrorMessage}
                            onChange={(value) => setNewPassword(value)}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <PasswordTextField
                            id="change-user-pwd-dialog-repeated-pwd-field"
                            label={_transl(UsersTranslationKey.CHANGE_PASSWORD_REPEATED_PASSWORD)}
                            errorMessage={repeatedPasswordErrorMessage}
                            onChange={(value) => setRepeatedPassword(value)}
                            required
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={onDialogClosed}/>
                <ChangePasswordButton onClick={saveChanges}/>
            </DialogActions>
        </Dialog>
    );
}
